export default "__VITE_ASSET__BHYKFNWI__"